<h4>{{ 'events.submissions.submission-list.subtitle' | translate | titlecase }}</h4>

<div class="mb-27">
  <div class="mb-27">
    <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10">
      <div>
        <label for="start-date">{{ 'events.submissions.submission-list.date-from' | translate | ucfirst }}</label>
        <input class="p-7 mh-7" type="date" name="date-from" id="date-from" [(ngModel)]="searchParams.SearchDateBegin" />
      </div>
      <div>
        <label for="date-to">{{ 'events.submissions.submission-list.date-to' | translate | ucfirst }}</label>
        <input class="p-7 mh-7" type="date" name="date-to" id="date-to" [(ngModel)]="searchParams.SearchDateEnd" />
      </div>
      <div>
        <p-checkbox [binary]="true" [(ngModel)]="searchParams.IncludeProcessedRequests" name="processed-requests"></p-checkbox>
        <label for="processed-requests">{{ 'events.submissions.submission-list.processed-requests' | translate | ucfirst }}</label>
      </div>
    </div>
  </div>
  <div class="mb-54">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="search()">
      {{ 'common.run-this-search' | translate | uppercase }}
    </button>
  </div>

  <div *ngIf="searchResult?.TotalCount">
    {{ 'events.submissions.submission-list.there-are' | translate | ucfirst }}
    <strong> {{ searchResult.TotalCount }} {{ 'events.submissions.submission-list.event-submissions' | translate | ucfirst }}</strong>
  </div>
</div>

<div class="atlas-table">
  <div class="mct-flex mct-row-reverse">
    <a (click)="exportEventSubmissions()">{{ 'events.submissions.submission-list.event-submissions-export' | translate | ucfirst }}</a>
  </div>
  <p-table [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [totalRecords]="searchResult?.TotalCount"
    [loading]="loading"
    [lazy]="true"
    (onLazyLoad)="lazyLoad($event)"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="EventName">
          {{ 'events.submissions.submission-list.name' | translate | ucfirst }}
          <p-sortIcon field="EventName"></p-sortIcon>
        </th>
        <th pSortableColumn="EventDate" [style]="{ width: '120px' }">
          {{ 'events.submissions.submission-list.event-date' | translate | ucfirst }}
          <p-sortIcon field="EventDate"></p-sortIcon>
        </th>
        <th pSortableColumn="Status" [style]="{ width: '120px' }">
          {{ 'events.submissions.submission-list.status' | translate | ucfirst }}
          <p-sortIcon field="Status"></p-sortIcon>
        </th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-eventSubmission>
      <tr>
        <td>{{ eventSubmission.EventName }}</td>
        <td>{{ eventSubmission.EventDate | date: 'M/d/yyyy' }}</td>
        <td>
          <span *ngIf="!eventSubmission.Approved && !eventSubmission.Rejected" style="color: gray">
            {{ 'events.submissions.submission-list.pending' | translate | ucfirst }}
          </span>
          <span *ngIf="eventSubmission.Approved" style="color: green">
            {{ 'events.submissions.submission-list.approved' | translate | ucfirst }}
          </span>
          <span *ngIf="eventSubmission.Rejected" style="color: red">
            {{ 'events.submissions.submission-list.rejected' | translate | ucfirst }}
          </span>
        </td>
        <td class="t-ac">
          <div>
            <action-button [label]="'common.actions' | translate | uppercase" [items]="actionItemsForEventSubmission(eventSubmission)">
            </action-button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <wl-page-size-dropdown
    [(pageSize)]="searchParams.PageSize"
    [pageSizes]="[20, 100, 0]"
    (pageSizeChange)="pageSizeChanged()"
  ></wl-page-size-dropdown>
</div>
